<template lang="jade">
  div(skin="sovereign" style="width: 100%")
    div.Stepper
      div.Step(v-for="step in steps"
               v-bind:class="{ 'Step--active': step.active, 'Step--disabled': step.actions.length === 0 }"            
               @click="click(step)")
        div.Step__header
          div.Step__indicator
            i.fa.fa-check.Step__symbol(v-if="false")
            span.Step__symbol(v-else) {{ step.subTitle }}
        div.Step__body
          div.Step__title {{ step.title }}
</template>
<script>
import _ from 'lodash'
import { navigation } from 'src/vuex/getters'

export default {
  data () {
    return {}
  },
  computed: {
    steps () {
      let steps = this.navigation
      return _.map(steps, xs => {
        return _.set(xs, 'active', _.includes(xs.class.match(/\w+/g), 'active'))
      })
    }
  },
  vuex: {
    getters: {
      navigation
    }
  },
  methods: {
    click (step) {
      step.cb(step)
    }
  }
}
</script>



// WEBPACK FOOTER //
// stepper.vue?4a32a868